module.exports = __webpack_public_path__ + "img/memory-course-4.3fa46345.png";